// src/pages/Dashboard/index.tsx
import React, { useState } from 'react';
import HourglassBottomTwoToneIcon from '@mui/icons-material/HourglassBottomTwoTone';
import { useNavigate } from 'react-router-dom';
import AtomButton from '@/components/atoms/Button';
import soonStyles from '@/pages/ComingSoon/soon.module.css';

const Soon = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/home');
  };
  return (
    <div className={soonStyles.container}>
      <HourglassBottomTwoToneIcon
        sx={{
          color: '#093fc3',
          fontSize: 50,
        }}
      />{' '}
      <h1>Coming Soon</h1>
      <h3>Feature in Development</h3>
      <p>We are working on this feature for the next update. Stay tuned!</p>
      <AtomButton
        variant="contained"
        onClick={goToHome}
        className={soonStyles.loginButton}
        disableElevation
      >
        Go to Home
      </AtomButton>
    </div>
  );
};

export default Soon;
